<script>
  import { bottomNavDetail } from '@/api/bottomNav'

  export default {
    name: 'BottomNavDrawer',
    props: {
      visible: {
        type: Boolean,
        default: false
      },
      id: {
        type: [Number, String],
        default: ''
      }
    },
    data() {
      return {
        loading: false,
        detailData: {
          id: '',
          name: '',
          imgUrl: '',
          optImgUrl: '',
          jumpPage: '',
          updateTime: '',
          logList: []
        }
      }
    },
    watch: {
      id: {
        handler(val) {
          if (val && this.visible) {
            this.getDetail()
          }
        },
        immediate: true
      },
      visible(val) {
        if (val && this.id) {
          this.getDetail()
        }
      }
    },
    methods: {
      // 获取详情
      async getDetail() {
        if (!this.id) return

        this.loading = true
        try {
          const res = await bottomNavDetail({ id: this.id })
          if (res.data) {
            this.detailData = res.data
          }
        } catch (error) {
          console.error('获取导航详情失败', error)
          this.$message.error('获取导航详情失败')
        } finally {
          this.loading = false
        }
      },

      // 关闭抽屉
      handleClose() {
        this.$emit('update:visible', false)
      }
    }
  }
</script>

<template>
  <el-drawer
    title="底部导航详情"
    :visible="visible"
    @close="handleClose"
    :with-header="true"
    size="500px"
    :before-close="handleClose"
    direction="rtl"
    custom-class="bottom-nav-drawer"
  >
    <div v-loading="loading" class="drawer-content">
      <!-- 基本信息 -->
      <div class="info-section">
        <div class="section-title">
          <div class="blue-line"></div>
          <span>基本信息</span>
        </div>

        <div class="info-item">
          <span class="label">入口：</span>
          <span class="value">{{ detailData.jumpPage }}</span>
        </div>

        <div class="info-item">
          <span class="label">名称：</span>
          <span class="value">{{ detailData.name }}</span>
        </div>

        <div class="info-item">
          <span class="label">生效时间：</span>
          <span class="value">{{ detailData.updateTime }}</span>
        </div>

        <div class="info-item images-row">
          <span class="label">图片：</span>
          <div class="image-container">
            <div class="image-item" v-if="detailData.imgUrl">
              <el-image
                :src="detailData.imgUrl"
                :preview-src-list="[detailData.imgUrl]"
                fit="contain"
                style="width: 80px; height: 80px"
              />
            </div>
            <div class="image-item" v-if="detailData.optImgUrl">
              <el-image
                :src="detailData.optImgUrl"
                fit="contain"
                style="width: 80px; height: 80px"
                :preview-src-list="[detailData.optImgUrl]"
              />
            </div>
          </div>
        </div>
      </div>

      <!-- 修改日志 -->
      <div class="info-section">
        <div class="section-title">
          <div class="blue-line"></div>
          <span>修改日志</span>
        </div>

        <div class="log-timeline" v-if="detailData.logList && detailData.logList.length > 0">
          <div class="timeline-container">
            <div v-for="(log, index) in detailData.logList" :key="index" class="timeline-item">
              <div class="timeline-left">
                <div class="timeline-dot"></div>
                <div class="timeline-line" v-if="index < detailData.logList.length - 1"></div>
              </div>
              <div class="timeline-content">
                <div class="log-header">
                  <span class="log-operator">{{ log.updatePerson }}</span>
                  <span class="log-date">{{ log.updateTime }}</span>
                </div>
                <div class="log-detail">
                  <div>生效时间：{{ log.updateTime }}</div>
                  <div class="log-images">
                    <el-image
                      v-if="log.imgUrl"
                      :src="log.imgUrl"
                      fit="contain"
                      style="width: 60px; height: 60px"
                      :preview-src-list="[log.imgUrl]"
                    />
                    <el-image
                      v-if="log.optImgUrl"
                      :src="log.optImgUrl"
                      fit="contain"
                      style="width: 60px; height: 60px"
                      :preview-src-list="[log.optImgUrl]"
                    />
                  </div>
                  <div style="line-height: 18px">{{ log.name }}</div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="no-data" v-else> 暂无修改记录 </div>
      </div>
    </div>
  </el-drawer>
</template>

<style scoped lang="scss">
  .bottom-nav-drawer {
    .drawer-content {
      padding: 20px;
    }

    .info-section {
      margin-bottom: 30px;
    }

    .section-title {
      display: flex;
      align-items: center;
      margin-bottom: 20px;

      .blue-line {
        width: 4px;
        height: 16px;
        background-color: #409eff;
        margin-right: 8px;
      }

      span {
        font-size: 16px;
        font-weight: bold;
      }
    }

    .info-item {
      margin-bottom: 15px;
      display: flex;

      .label {
        width: 80px;
        color: #606266;
        flex-shrink: 0;
      }

      .value {
        flex: 1;
        color: #303133;
      }

      &.images-row {
        align-items: flex-start;
      }

      .image-container {
        display: flex;
        flex-wrap: wrap;

        .image-item {
          margin-right: 10px;
          margin-bottom: 10px;
        }
      }
    }

    .timeline-container {
      position: relative;
      padding-left: 20px;

      .timeline-item {
        display: flex;
        margin-bottom: 20px;
        position: relative;

        .timeline-left {
          position: absolute;
          left: -20px;
          top: 0;
          height: 100%;
          width: 20px;
          display: flex;
          flex-direction: column;
          align-items: center;

          .timeline-dot {
            width: 10px;
            height: 10px;
            border-radius: 50%;
            background-color: #409eff;
            margin-top: 10px;
            z-index: 1;
          }

          .timeline-line {
            width: 2px;
            flex-grow: 1;
            background-color: #ebeef5;
            margin-top: 5px;
          }
        }

        .timeline-content {
          flex: 1;
          padding-bottom: 20px;

          .log-header {
            display: flex;
            justify-content: space-between;
            margin-bottom: 10px;

            .log-operator {
              font-weight: bold;
              color: #303133;
            }

            .log-date {
              color: #909399;
              font-size: 12px;
            }
          }

          .log-detail {
            padding: 10px;
            background-color: #f5f7fa;
            border-radius: 4px;
            color: #606266;
            font-size: 14px;

            .log-images {
              margin-top: 10px;
              display: flex;
              flex-wrap: wrap;
              gap: 10px;
            }
          }
        }
      }
    }

    .no-data {
      text-align: center;
      color: #909399;
      padding: 20px 0;
    }
  }
</style>
